// getters
const papeleriaProducts = state => state.papeleriaProducts

export default {
  papeleriaProducts
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/products/getters.js